export const MESSAGES = {
    // Both of these are ORDINARY outcomes of reading a consultation's mental-health answer, not
    // faults: the question predates most consultations, and the API only lets the treating
    // clinician read a paid one. The patient history renders several consultations at once, so
    // without these the page would raise a stack of red toasts every time it loaded.
    // NB the first is the raw key, not prose: MENTAL_HEALTH_REVIEW_NOT_FOUND has no entry in the
    // backend's locales/en.json, and i18n returns the key when a translation is missing.
    'MENTAL_HEALTH_REVIEW_NOT_FOUND': true,
    'No access to the appointment': true,
    'Reschedule appointments first': true,
    'You can’t remove session with active appointments': true,
}